import { makeRequestWithRetry } from 'src/utils/graphql';
import { QUERY_RETAILER_LISTING } from '../queries';
import { Coordinate, RetailerActions, RetailerEntity } from './types';
// import mock from './mock.json';

import { ActionCreatorType } from 'src/store';

export const fetchRetailerData = async () => {
  let start = 0;
  let stores = [];

  do {
    const response = await makeRequestWithRetry<{ stores: RetailerEntity[] }>(
      QUERY_RETAILER_LISTING,
      {
        start,
      },
      { errorId: 'fetchRetailerData()' }
    );

    stores = [...stores, ...response.stores];
    start += 100;
  } while (stores.length === start);

  return { stores };
};

const {
  FetchRetailerSuccess,
  SetFilter,
  SetMap,
  SetMarkers,
  ChangeMapBounds,
  SetCurrentLocation,
} = RetailerActions;

export const fetchRetailerDataSuccess = (results) => ({
  type: FetchRetailerSuccess,
  payload: results,
});

export const setFilter = (filters) => ({ type: SetFilter, payload: { filters } });

export const setMap: ActionCreatorType = (map) => ({
  type: SetMap,
  payload: {
    map,
  },
});

export const setMarkers: ActionCreatorType = (markers) => ({
  type: SetMarkers,
  payload: {
    markers,
  },
});

export const changeMapBounds: ActionCreatorType = () => ({
  type: ChangeMapBounds,
});

export const setCurrentLocation = (location: Coordinate) => ({
  type: SetCurrentLocation,
  payload: {
    location,
  },
});

// export const setSort = (sort: StoreSort) => ({
//   type: SetSort,
//   payload: {
//     sort,
//   },
// });
